<template>
	<div class="InventoryDashboardGraph">
		<div
			v-if="isGraphDataAvailable"
			ref="inventoryGraph"
			style="width: 100%; height: 450px; overflow: hidden;"
		></div>
		<div v-else>
			<h3 style="text-align: center; padding-top: 50px;">No Data Found</h3>
		</div>
	</div>
</template>
<script>
var echarts = require("echarts");
import { GraphData } from "../../../../../mixins/baseReportGraphData";
import { EventBus } from "../../../../eventBus";
import moment from "moment";

export default {
	name: "InventoryDashboardGraph",
	mixins: [GraphData],
	data() {
		return {
			inventoryGraphInstance: "",
			// colors: ["#C7FFFE", "#FFCEE3", "#FFB1D2"],
			colors: ["#e29d5a", "#f9cb9c", "#fce5cd"],
			isGraphDataAvailable: true
		};
	},
	mounted() {
		this.initBaseGraph();
		EventBus.$on("reponseOfInventory", data => {
			this.isGraphDataAvailable = true;
			setTimeout(() => {
				this.initBaseGraph();
				this.map_graph_data(data.data, data.name);
			}, 0);
			// console.log("graph", data);
		});
	},
	beforeDestroy() {
		EventBus.$off();
	},
	methods: {
		map_graph_data(graph_data, name) {
			this.graphXaxis[0].data = [];
			this.graphSeries = [];

			this.getNameOfGraph = name == "stockout" ? "Opportunity" :`${name} Report`;
			this.graphColors = this.colors;
			if (name != "stockout") {
				if (graph_data.length) {
					this.isGraphDataAvailable = true;
					let stock = {
						name: "System Stock",
						type: "bar",
						data: []
					};
	
					let usage = {
						name: name == "usage" ? "usage" : "Actual Stock",
						type: "bar",
						data: []
					};
	
					this.graphXaxis[0].axisLabel.rotate = 20;
					this.graphXaxis[0].axisLabel.margin = 10;
					this.graphXaxis[0].axisLine = {
						show: false
					};
					this.graphXaxis[0].axisTick = {
						show: false
					};
					for (var i = 0; i < graph_data.length; i++) {
						let name = graph_data[i].name;
						if (name.length > 20) {
							name = name.slice(0, 20);
							name = name + "...";
						}
						this.graphXaxis[0].data.push(name);
						stock.data.push(graph_data[i].stock_units_sum);
						usage.data.push(graph_data[i].usage_sum);
					}
					stock.barWidth = 25;
					usage.barWidth = 25;
					this.graphSeries.push(stock);
					this.graphSeries.push(usage);
				} else {
					this.isGraphDataAvailable = false;
				}
			} else {
				if (graph_data.length) {
					this.isGraphDataAvailable = true;
					let stock = {
						name: "UNMET DEMAND",
						type: "bar",
						data: []
					};
	
					let usage = {
						name: "FORECAST",
						type: "bar",
						data: []
					};
					let sold = {
						name: "QUANTITY SOLD",
						type: "bar",
						data: []
					};
	
					this.graphXaxis[0].axisLabel.rotate = 20;
					this.graphXaxis[0].axisLabel.margin = 10;
					this.graphXaxis[0].axisLine = {
						show: false
					};
					this.graphXaxis[0].axisTick = {
						show: false
					};
					for (var i = 0; i < graph_data.length; i++) {
						let name = graph_data[i].name;
						if (name.length > 20) {
							name = name.slice(0, 20);
							name = name + "...";
						}
						this.graphXaxis[0].data.push(name);
						stock.data.push(graph_data[i].unmet_quantity);
						usage.data.push(graph_data[i].forecast);
						sold.data.push(graph_data[i].sale_qty);
					}
					stock.barWidth = 25;
					usage.barWidth = 25;
					sold.barWidth = 25;
					this.graphSeries.push(stock);
					this.graphSeries.push(usage);
					this.graphSeries.push(sold);
				} else {
					this.isGraphDataAvailable = false;
				}
			}

			this.reRenderGraph();
			// console.log("graphData", this.graphData);
		},

		clearGraph: function() {
			this.inventoryGraphInstance.clear();
		},

		reRenderGraph: function() {
			this.clearGraph();
			this.inventoryGraphInstance.setOption(this.graphData);
			this.inventoryGraphInstance.hideLoading();
		},

		initBaseGraph() {
			let baseGraphContainer = this.$refs["inventoryGraph"];
			this.inventoryGraphInstance = echarts.init(
				baseGraphContainer,
				null,
				this.initOptions
			);
			this.inventoryGraphInstance.showLoading();
		}
	}
};
</script>
<style>
.InventoryDashboardGraph tspan {
	text-transform: capitalize;
}
.InventoryDashboardGraph text {
	width: 150px;
	text-overflow: ellipsis;
	overflow: hidden;
}
</style>
